import React, { useEffect } from 'react';
import { initFacebookPixel } from '../facebookPixel';
import { Link } from 'react-router-dom';
import './Signup.css';

const Signup = () => {
  const handleBookTrial = () => {
    window.location.href = '/book-trial';
  };
  
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  
  return (
    <div className="stick">
      <button onClick={handleBookTrial} className="sticky-button">
        Book Trial for Swimming
      </button>
    </div>
  );
};

export default Signup;